module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "coach-info"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('img', {
    attrs: {
      "src": _vm.formData.icon
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.formData.name) + "\n        "), _c('span', [_vm._v(_vm._s(_vm.formData.mobile))])]), _vm._v(" "), _c('h2', [_c('span', [_vm._v(_vm._s(_vm.formData.certificationDesc))])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.formData.specialty))])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.editClick
    }
  }, [_vm._v("编辑教练")])], 1)]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "value": _vm.activeName
    },
    on: {
      "tab-click": _vm.handleClick
    }
  }, _vm._l((_vm.tabs), function(item) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.label,
        "name": item.name
      }
    })
  }), 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4ebac2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/program/view/index.vue
// module id = 1207
// module chunks = 2